export default __webpack_public_path__ + "static/media/tomatoes.36aed10c.jpg";